import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { actions as popupActions } from '~/redux/reducers/popup';
import { actions as tripActions } from '~/redux/reducers/trip';
import { actions as appActions } from '~/redux/reducers/app';
import { createBookLink } from '~/utils/payment';
import { getCookie } from '~/utils/helpers';
import { isDateStatusMatch } from '~/utils/trip';
import { triggerAddToCart } from '~/utils/data-layer';
import getCurrentCountrySite from '~/utils/region-site-config';
import { mapMultiTierPricesToDisplay } from '~/utils/trip';
import BookActionDesktop from '../TripDetail/BookActionDesktop';
import config from '~/config';
import withTrip from './withTrip';

const ActionContainer = styled.div`
  padding-top: ${props => (props.paddingTop ? '16px' : 0)};
`;

const enhance = connect(
  state => ({
    sessionData: state.session.data,
    availability: state.availability,
    user: state.session.user,
    multiTierQuantity: state.trip.multiTierQuantity,
    selectedMultiTier: state.trip.selectedMultiTier,
  }), {
    logRequest: tripActions.logRequest,
    openTourCategory: popupActions.openTourCategory,
    globalLoad: appActions.loading,
  }
);

class ActionButton extends Component {
  static propTypes = {
    availability: PropTypes.object,
    customize: PropTypes.bool,
    trip: PropTypes.object,
    sessionData: PropTypes.object,
    user: PropTypes.object,
    multiTierQuantity: PropTypes.array,
    logRequest: PropTypes.func,
    openTourCategory: PropTypes.func,
    globalLoad: PropTypes.func,
    openCustomizeQty: PropTypes.func,
    selectedMultiTier: PropTypes.object,
  };

  onRequestV2 = (event, requestType, device, link, quantity) => {
    const { trip, multiTierQuantity } = this.props;
    if (event) {
      triggerAddToCart(trip);
      // dataLayer().push({
      //   event: 'Dynamic Remarketing - Click Book or Message',
      //   dynamic_remarketing_trip_id: trip._id,
      //   fbads_event: 'AddToCart',
      //   gads_event: 'add_to_cart',
      //   gads_params: [{
      //     id: trip._id,
      //     google_business_vertical: 'custom',
      //   }],
      //   dynx_itemid: trip._id,
      //   dynx_pagetype: eventMapping.add_to_cart,
      // });
      this.props.logRequest({
        tripId: trip._id,
        quantity,
        multiTierQuantity,
        requestType,
        device,
      });
      if (trip.product_type === 'trip' && trip.trip_type === 'joined' && !getCookie('joinTourInformed')) {
        this.props.openTourCategory(true, link, '_self', trip.destination_location);
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
      this.props.globalLoad();
    }
    return true;
  }

  render() {
    const { availability, customize, trip, sessionData, user, selectedMultiTier: currentSelectedMultiTier } = this.props;
    const { currency, quantity, childQuantity } = sessionData;
    const { acceptSwap } = availability;
    let { selectedDate } = availability;
    if (selectedDate.length === 0) selectedDate = sessionData.date;
    const available = isDateStatusMatch('available', selectedDate, availability.availabilities);
    const availableText = available ? 'Instant Book' : 'Book';
    const isChildEnabled = trip.additional_options && !!trip.additional_options.find(option => option.type === 'child_price');
    const childPrice = isChildEnabled && trip.additional_options.find(option => option.type === 'child_price').price;
    const bookButtonDisabled = (trip.user_id && user && (user._id === trip.user_id._id))
                               || (trip.product_type === 'ticket' && (currentSelectedMultiTier || []).length <= 0);
    const tripSelectedMultiTier = trip.multi_tier_prices.map(mapMultiTierPricesToDisplay);
    const selectedMultiTier = currentSelectedMultiTier || tripSelectedMultiTier;
    const fixPath = config.baseURL[getCurrentCountrySite().toLowerCase()];
    const bookLink = createBookLink(
      fixPath,
      'book',
      trip,
      selectedDate,
      { quantity, childQuantity },
      { acceptSwap },
      selectedMultiTier
    );
    const messageLink = trip.product_type === 'trip'
      ? createBookLink(
        fixPath,
        'message',
        trip,
        selectedDate,
        { quantity, childQuantity },
        { acceptSwap },
        selectedMultiTier
      )
      : 'https://m.me/Takemetour';
    const messageLinkProps = (trip.product_type !== 'trip') && { target: '_blank', rel: 'noopener noreferrer' };
    const messageLabel = (trip.product_type !== 'trip') ? 'Ask for Detail' : 'Ask Local Expert';
    return (
      <ActionContainer paddingTop={customize}>
        <BookActionDesktop
          label={availableText}
          customize={customize}
          trip={trip}
          currency={currency}
          childPrice={childPrice}
          disabled={bookButtonDisabled}
          bookLink={bookLink}
          hideMessageButton={trip.is_message_disabled}
          messageLink={messageLink}
          messageLinkProps={messageLinkProps}
          onClickBook={(e) => this.onRequestV2(e, 'book', 'desktop', bookLink, quantity)}
          onClickMessage={(e) => this.onRequestV2(e, 'message', 'desktop', messageLink, quantity)}
          onClickCustomize={() => this.props.openCustomizeQty({ quantity, childQuantity, selectedDate })}
          messageLabel={messageLabel}
          isLoadingPricing={trip.isLoadingPricing}
          isMasterTrip={trip.is_master_trip}
        />
      </ActionContainer>
    );
  }
}

export default withTrip(enhance(ActionButton));
